import { Box, Grid, Paper, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { theme } from '../../../shared/theme';
import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

const paperStyle = {
    padding: '0px 0px 0px 0px',
    minWidth: 400,
    maxWidth: 500,
    borderRadius: `${theme.palette.custom.button.borderRadius}`,
    boxShadow:
        '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
};

export default function RegisterationConfirmation() {
    const location = useLocation() as { state?: { firstName?: string } };
    const firstName = location.state?.firstName;

    if (!firstName) {
        return <Navigate to='/register' replace />;
    }

    return (
        <Box
            component='main'
            sx={{
                position: 'relative',
                width: '100vw',
                minHeight: 'var(--app-viewport-height)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: theme.palette.custom.loggedOutBackgroundImage,
                backgroundAttachment: { xs: 'scroll', md: 'fixed' },
                backgroundSize: 'cover',
                overflow: 'auto',
                p: { xs: 2, sm: 3 },
            }}
        >
            {' '}
            <Grid component='section' aria-label='Thankyou'>
                <Paper elevation={isMobile ? 0 : 10} style={paperStyle}>
                    <Grid
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: theme.palette.neutral.main,
                            justifyContent: 'center',
                            alignItems: 'center',
                            alignContent: 'center',
                            padding: '35px',
                            borderTopLeftRadius: `${theme.palette.custom.button.borderRadius}`,
                            borderTopRightRadius: `${theme.palette.custom.button.borderRadius}`,
                        }}
                    >
                        <img
                            alt='primarylogo'
                            src={theme.palette.custom.lightLogo}
                            style={{ width: '170px', height: 'auto' }}
                        />
                    </Grid>

                    <Grid
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            padding: '35px',
                            gap: 2,
                        }}
                    >
                        <Typography
                            component='h1'
                            variant='h5'
                            sx={{
                                letterSpacing: '-0.5px',
                            }}
                        >
                            Registration Successful
                        </Typography>
                        <Typography variant='body3'>
                            Thank you for registering with 7DAY. We have just
                            sent you an email to confirm your email address is
                            correct. You will be prompted to click on the link
                            and verify your email address and will return back
                            to the website. If you do not receive an email
                            please check your spam folder.
                        </Typography>
                        <Typography variant='body3'>
                            If you have any issues please contact{' '}
                            <span
                                style={{ color: `${theme.palette.green.main}` }}
                            >
                                support@7-day.com
                            </span>
                            .
                        </Typography>
                        <Typography variant='body3'>Regards,</Typography>
                        <Typography variant='body3'>The 7DAY Team</Typography>
                    </Grid>
                </Paper>
            </Grid>
        </Box>
    );
}
